<script>
import Response from "../playground/ResultadoApi.vue";
import playground from "../../../mixins/playground/playground";
import OabProcessosFormModal from "../playground/OabProcessosFormModal.vue"
import ButtonLoading from "../../_www/Button/ButtonLoading.vue";

export default {
  name: "OabProcessos",
  mixins:[playground],
  components: {
    OabProcessosFormModal,
    ButtonLoading,
    Response
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    extra: {
      type: Object,
      default: () => ({}),
      required: true,
    }
  },
  data() {
    return {
      termo: "",
      oab_estado: this.extra.estados[0]['sigla'],
      oab_numero: '',
      filtros: {
        tribunais: [],
        dateOne: "",
        dateTwo: "",
        oab_tipo: null,
        ordem: 'desc',
        status: null
      }
    };
  },
  computed: {
    quantidadeFiltros() {
      let total = 0;

      if (this.filtros.oab_tipo !== null) total++;
      if (this.filtros.status !== null) total++;
      if (this.filtros.ordem !== 'desc') total++;
      if (this.filtros.dateOne.length) total++
      if (this.filtros.dateTwo.length) total++
      total += this.filtros.tribunais.length;

      return total;
    },
    informacoes() {
      if(!this.response['advogado_encontrado']) {
        return null;
      }

      let info = [{
          label: 'Processos encontrados',
          value: this.response['advogado_encontrado']['quantidade_processos']
      }];

      if (this.response['advogado_encontrado']['tipo_pessoa']) {
        info.push({
          label: 'Tipo', value: this.response['advogado_encontrado']['tipo_pessoa']
        });
      }

      if(this.response['advogado_encontrado']['nome']) {
        info.unshift({
          label: 'Nome', value: this.response['advogado_encontrado']['nome']
        });
      }

      return info;
    }
  },
  methods: {
    params() {
      let searchParams = {
        oab_estado: this.oab_estado,
        oab_numero: this.oab_numero,
        token_id: this.token,
      }

      if (this.filtros.dateOne.length) {
        searchParams['data_minima'] = this.filtros.dateOne;
      }

      if (this.filtros.dateTwo.length) {
        searchParams['data_maxima'] = this.filtros.dateTwo;
      }

      if (this.filtros.tribunais.length) {
        searchParams['tribunais'] = this.filtros.tribunais;
      }

      if (this.filtros.oab_tipo) {
        searchParams['oab_tipo'] = this.filtros.oab_tipo;
      }

      if (this.filtros.ordem !== 'desc') {
        searchParams['ordem'] = this.filtros.ordem;
      }

      if (this.filtros.status !== null) {
        searchParams['status'] = this.filtros.status ? 'ATIVO' : 'INATIVO';
      }

      return { query: searchParams };
    },
    inputInvalido() {
      return !this.termo.oab_numero.length;
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    atualizarFiltro(filtro) {
      Object.assign(this.filtros, filtro);
    },
  }
}
</script>

<template>
  <div>
    <form id="form-playground-oab" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="selectEstados" class="font-medium text-sm">Estado</label>
        <select
          id="selectEstados"
          name="selectEstados"
          v-model="oab_estado"
          class="field px-3 rounded-md text-sm block"
        >
          <option v-for="estado in extra.estados" :value="estado.sigla">
            {{ estado.nome }}
          </option>
        </select>
      </div>

      <div class="space-y-2">
        <label for="numero_oab" class="font-medium text-sm">Número da OAB</label>
        <input
          id="numero_oab"
          name="numero_oab"
          v-model="oab_numero"
          class="input is-large px-2 rounded-md block"
          type="number"
          required="required"
          autofocus="autofocus"
          placeholder="000000"
        />
      </div>
    </form>

    <Btn
      class="btn playground-button filtro-button"
      type="button"
      :disabled="$wait.is(`fetching_${this.identificador}`)"
      @click="openModal">
      Filtros <span>{{ quantidadeFiltros }}</span>
    </Btn>

    <div class="custo">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || showModal"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>

    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :informacoes-principais="informacoes"
      @carregar-mais-oab-processos="carregarMais()"
    >
    </Response>

    <oab-processos-form-modal
      :visible="showModal"
      :tribunais="extra.tribunais"
      :filtros="filtros"
      @addFiltro="atualizarFiltro"
      @closeModal="closeModal"
    />
  </div>
</template>

<style scoped lang="stylus">
.custo
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.form-playground
  display flex
  flex-direction column
  gap 15px

.form-playground .input
  width 18.5rem
  @media (max-width: 768px)
    width 100%

.filtro-button
  padding 10px 20px
  margin-top 1rem

.filtro-button span
  color #2393ae
  background-color ghostwhite
  padding 10px
  border-radius 50%
  margin-left 8px

.playground-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px
  font-weight 500

.playground-button:hover
  opacity 0.8

.consultar-button
  padding 20px 40px
</style>
